/**
 * Smileys & Emotion emoji category with searchable keywords
 */
export const smileys = {
  name: 'Smileys',
  icon: '😀',
  emojis: [
    { emoji: '😀', keywords: ['grin', 'happy', 'smile', 'face', 'joy'] },
    { emoji: '😃', keywords: ['smile', 'happy', 'open', 'mouth', 'joy'] },
    { emoji: '😄', keywords: ['smile', 'happy', 'eyes', 'grin', 'laugh'] },
    { emoji: '😁', keywords: ['grin', 'beam', 'happy', 'smile', 'teeth'] },
    { emoji: '😆', keywords: ['laugh', 'satisfied', 'happy', 'lol', 'xd'] },
    { emoji: '😅', keywords: ['sweat', 'nervous', 'laugh', 'relief', 'awkward'] },
    { emoji: '🤣', keywords: ['rofl', 'laugh', 'crying', 'funny', 'lmao'] },
    { emoji: '😂', keywords: ['joy', 'laugh', 'cry', 'tears', 'funny', 'lol'] },
    { emoji: '🙂', keywords: ['smile', 'slight', 'okay', 'fine', 'content'] },
    { emoji: '🙃', keywords: ['upside', 'down', 'sarcasm', 'silly', 'ironic'] },
    { emoji: '😉', keywords: ['wink', 'flirt', 'playful', 'hint', 'joke'] },
    { emoji: '😊', keywords: ['blush', 'smile', 'happy', 'warm', 'shy'] },
    { emoji: '😇', keywords: ['angel', 'innocent', 'halo', 'blessed', 'good'] },
    { emoji: '🥰', keywords: ['love', 'hearts', 'adore', 'affection', 'crush'] },
    { emoji: '😍', keywords: ['love', 'heart', 'eyes', 'crush', 'adore'] },
    { emoji: '🤩', keywords: ['star', 'eyes', 'excited', 'amazed', 'wow'] },
    { emoji: '😘', keywords: ['kiss', 'love', 'heart', 'flirt', 'xoxo'] },
    { emoji: '😗', keywords: ['kiss', 'whistle', 'lips', 'peck'] },
    { emoji: '☺️', keywords: ['smile', 'blush', 'content', 'happy', 'warm'] },
    { emoji: '😚', keywords: ['kiss', 'closed', 'eyes', 'love', 'sweet'] },
    { emoji: '😙', keywords: ['kiss', 'smile', 'happy', 'love'] },
    { emoji: '🥲', keywords: ['smile', 'tear', 'grateful', 'touched', 'bittersweet'] },
    { emoji: '😋', keywords: ['yummy', 'delicious', 'tongue', 'tasty', 'food'] },
    { emoji: '😛', keywords: ['tongue', 'playful', 'silly', 'tease', 'blep'] },
    { emoji: '😜', keywords: ['wink', 'tongue', 'crazy', 'silly', 'playful'] },
    { emoji: '🤪', keywords: ['crazy', 'zany', 'wild', 'silly', 'goofy'] },
    { emoji: '😝', keywords: ['tongue', 'squint', 'playful', 'gross', 'bleh'] },
    { emoji: '🤑', keywords: ['money', 'rich', 'dollar', 'greedy', 'cash'] },
    { emoji: '🤗', keywords: ['hug', 'embrace', 'warm', 'love', 'welcome'] },
    { emoji: '🤭', keywords: ['giggle', 'oops', 'shy', 'cover', 'tee-hee'] },
    { emoji: '🤫', keywords: ['shush', 'quiet', 'secret', 'silent', 'hush'] },
    { emoji: '🤔', keywords: ['think', 'hmm', 'wonder', 'consider', 'ponder'] },
    { emoji: '🤐', keywords: ['zipper', 'quiet', 'secret', 'mute', 'sealed'] },
    { emoji: '🤨', keywords: ['raised', 'eyebrow', 'skeptic', 'doubt', 'sus'] },
    { emoji: '😐', keywords: ['neutral', 'meh', 'blank', 'expressionless', 'poker'] },
    { emoji: '😑', keywords: ['expressionless', 'blank', 'annoyed', 'unimpressed'] },
    { emoji: '😶', keywords: ['silent', 'speechless', 'mute', 'no', 'words'] },
    { emoji: '😏', keywords: ['smirk', 'smug', 'sly', 'flirt', 'suggestive'] },
    { emoji: '😒', keywords: ['unamused', 'annoyed', 'side', 'eye', 'meh'] },
    { emoji: '🙄', keywords: ['eye', 'roll', 'annoyed', 'whatever', 'ugh'] },
    { emoji: '😬', keywords: ['grimace', 'awkward', 'nervous', 'cringe', 'yikes'] },
    { emoji: '🤥', keywords: ['lie', 'pinocchio', 'nose', 'fib', 'dishonest'] },
    { emoji: '😌', keywords: ['relieved', 'peaceful', 'calm', 'content', 'zen'] },
    { emoji: '😔', keywords: ['sad', 'pensive', 'down', 'disappointed', 'sorry'] },
    { emoji: '😪', keywords: ['sleepy', 'tired', 'snot', 'bubble', 'drowsy'] },
    { emoji: '🤤', keywords: ['drool', 'hungry', 'want', 'desire', 'yum'] },
    { emoji: '😴', keywords: ['sleep', 'zzz', 'tired', 'nap', 'rest'] },
    { emoji: '😷', keywords: ['mask', 'sick', 'covid', 'ill', 'doctor'] },
    { emoji: '🤒', keywords: ['sick', 'fever', 'thermometer', 'ill', 'unwell'] },
    { emoji: '🤕', keywords: ['hurt', 'bandage', 'injured', 'headache', 'pain'] },
    { emoji: '🤢', keywords: ['nausea', 'sick', 'green', 'queasy', 'gross'] },
    { emoji: '🤮', keywords: ['vomit', 'puke', 'sick', 'throw', 'up', 'gross'] },
    { emoji: '🤧', keywords: ['sneeze', 'sick', 'cold', 'tissue', 'achoo'] },
    { emoji: '🥵', keywords: ['hot', 'heat', 'sweat', 'fever', 'burning'] },
    { emoji: '🥶', keywords: ['cold', 'freeze', 'ice', 'winter', 'frozen'] },
    { emoji: '🥴', keywords: ['woozy', 'drunk', 'dizzy', 'tipsy', 'confused'] },
    { emoji: '😵', keywords: ['dizzy', 'dead', 'knocked', 'out', 'spiral'] },
    { emoji: '🤯', keywords: ['mind', 'blown', 'explode', 'shocked', 'amazed'] },
    { emoji: '🤠', keywords: ['cowboy', 'hat', 'western', 'yeehaw', 'country'] },
    { emoji: '🥳', keywords: ['party', 'celebrate', 'birthday', 'confetti', 'fun'] },
    { emoji: '🥸', keywords: ['disguise', 'incognito', 'glasses', 'mustache', 'spy'] },
    { emoji: '😎', keywords: ['cool', 'sunglasses', 'awesome', 'chill', 'boss'] },
    { emoji: '🤓', keywords: ['nerd', 'geek', 'glasses', 'smart', 'study'] },
    { emoji: '🧐', keywords: ['monocle', 'inspect', 'curious', 'hmm', 'fancy'] },
    { emoji: '😕', keywords: ['confused', 'puzzled', 'unsure', 'what', 'huh'] },
    { emoji: '😟', keywords: ['worried', 'concerned', 'anxious', 'nervous', 'frown'] },
    { emoji: '🙁', keywords: ['sad', 'frown', 'unhappy', 'down', 'disappointed'] },
    { emoji: '☹️', keywords: ['frown', 'sad', 'unhappy', 'disappointed'] },
    { emoji: '😮', keywords: ['wow', 'surprised', 'open', 'mouth', 'oh'] },
    { emoji: '😯', keywords: ['hushed', 'surprised', 'stunned', 'quiet', 'wow'] },
    { emoji: '😲', keywords: ['astonished', 'shocked', 'amazed', 'wow', 'omg'] },
    { emoji: '😳', keywords: ['flushed', 'embarrassed', 'shy', 'blush', 'awkward'] },
    { emoji: '🥺', keywords: ['pleading', 'puppy', 'eyes', 'please', 'begging'] },
    { emoji: '😦', keywords: ['frown', 'open', 'mouth', 'worried', 'concerned'] },
    { emoji: '😧', keywords: ['anguished', 'worried', 'stressed', 'concerned'] },
    { emoji: '😨', keywords: ['fear', 'scared', 'anxious', 'worried', 'terrified'] },
    { emoji: '😰', keywords: ['anxious', 'sweat', 'nervous', 'worried', 'stressed'] },
    { emoji: '😥', keywords: ['sad', 'relieved', 'sweat', 'disappointed'] },
    { emoji: '😢', keywords: ['cry', 'sad', 'tear', 'upset', 'unhappy'] },
    { emoji: '😭', keywords: ['sob', 'cry', 'tears', 'sad', 'wail', 'bawl'] },
    { emoji: '😱', keywords: ['scream', 'horror', 'scared', 'shocked', 'fear'] },
    { emoji: '😖', keywords: ['confounded', 'frustrated', 'upset', 'stressed'] },
    { emoji: '😣', keywords: ['persevere', 'struggle', 'frustrated', 'trying'] },
    { emoji: '😞', keywords: ['disappointed', 'sad', 'down', 'dejected', 'let'] },
    { emoji: '😓', keywords: ['downcast', 'sweat', 'sad', 'disappointed', 'cold'] },
    { emoji: '😩', keywords: ['weary', 'tired', 'frustrated', 'exhausted', 'ugh'] },
    { emoji: '😫', keywords: ['tired', 'exhausted', 'frustrated', 'fed', 'up'] },
    { emoji: '🥱', keywords: ['yawn', 'tired', 'sleepy', 'bored', 'boring'] },
    { emoji: '😤', keywords: ['triumph', 'huffing', 'proud', 'frustrated', 'steam'] },
    { emoji: '😡', keywords: ['angry', 'mad', 'rage', 'pout', 'furious'] },
    { emoji: '😠', keywords: ['angry', 'mad', 'annoyed', 'grumpy', 'upset'] },
    { emoji: '🤬', keywords: ['swear', 'curse', 'angry', 'symbols', 'censored'] },
    { emoji: '😈', keywords: ['devil', 'evil', 'mischief', 'horns', 'naughty'] },
    { emoji: '👿', keywords: ['devil', 'angry', 'evil', 'demon', 'imp'] },
    { emoji: '💀', keywords: ['skull', 'dead', 'death', 'skeleton', 'dying'] },
    { emoji: '☠️', keywords: ['skull', 'crossbones', 'death', 'danger', 'poison'] },
    { emoji: '💩', keywords: ['poop', 'poo', 'shit', 'crap', 'turd'] },
    { emoji: '🤡', keywords: ['clown', 'circus', 'funny', 'joke', 'fool'] },
    { emoji: '👹', keywords: ['ogre', 'monster', 'demon', 'scary', 'japanese'] },
    { emoji: '👺', keywords: ['goblin', 'tengu', 'monster', 'japanese', 'mask'] },
    { emoji: '👻', keywords: ['ghost', 'boo', 'halloween', 'spooky', 'spirit'] },
    { emoji: '👽', keywords: ['alien', 'ufo', 'space', 'extraterrestrial', 'et'] },
    { emoji: '👾', keywords: ['alien', 'monster', 'game', 'invader', 'pixel'] },
    { emoji: '🤖', keywords: ['robot', 'bot', 'machine', 'android', 'ai'] },
  ],
};

export default smileys;

